function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { white, gray800 } from '../theme/colors';
import { elevationThree } from '../theme/elevations';
import { fontSemiBold } from '../theme/fonts';
import { size4, size8, size12 } from '../theme/scale';
import styled from 'styled-components';
const StyledTooltip = styled(ReactTooltip)`
  box-shadow: ${elevationThree} !important;
  font-family: ${fontSemiBold} !important;
  font-size: ${size12} !important;
  border-radius: ${size4} !important;
  padding: ${size8} !important;

  &.show {
    opacity: 1 !important;
  }
`;
const Tooltip = ({
  ...props
}) => /*#__PURE__*/React.createElement(StyledTooltip, _extends({
  backgroundColor: gray800,
  textColor: white
}, props));
Tooltip.show = ReactTooltip.show;
Tooltip.hide = ReactTooltip.hide;
Tooltip.rebuild = ReactTooltip.rebuild;
export default Tooltip;
//# sourceMappingURL=index.js.map